import React, { useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

import { articleType } from 'common/constants/content';
import DragTable from './drag-table';
import { UPDATE_ARTICLE_POSITION } from '../../gql';

export default function ArticleListModal({
  visible = false,
  onClose = () => {},
  refetch = () => {},
  properties = [],
  bookings = [],
  payment = [],
}) {
  const { t } = useTranslation();
  const [propertiesList, setPropertiesList] = useState(properties);
  const [bookingsList, setBookingsList] = useState(bookings);
  const [paymentList, setPaymentList] = useState(payment);

  const [updateArticlePosition] = useMutation(UPDATE_ARTICLE_POSITION, {
    onCompleted: result => {
      if (result?.updateArticlePosition?.success) {
        refetch();
        onClose();
      }
    },
  });

  const handleIdsArr = targetArr => {
    const idxs = [];
    targetArr.forEach(item => idxs.push(item.id));
    return idxs;
  };

  const handleConfirm = () => {
    const propertiesIdx = handleIdsArr(propertiesList);
    const bookingsIdx = handleIdsArr(bookingsList);
    const paymentIdx = handleIdsArr(paymentList);
    const variables = {
      input: {
        booking: bookingsIdx,
        property: propertiesIdx,
        payment: paymentIdx,
      },
    };
    updateArticlePosition({ variables });
  };

  return (
    <Modal
      visible={visible}
      width={812}
      className="article-list-modal"
      onCancel={onClose}
      centered
      okText={t('cms.properties.edit.leave_alert.title')}
      onOk={handleConfirm}
    >
      <div className="title">Manage Article List</div>
      <div className="subtitle">You can manage all articles here</div>
      <DragTable
        refetch={refetch}
        data={propertiesList}
        title={t('cms.content.article.title.properties')}
        type={articleType.PROPERTY}
        setData={data => setPropertiesList(data)}
      />
      <DragTable
        refetch={refetch}
        data={bookingsList}
        title={t('cms.content.article.title.bookings')}
        type={articleType.BOOKING}
        setData={data => setBookingsList(data)}
      />
      <DragTable
        refetch={refetch}
        data={paymentList}
        title={t('cms.content.article.title.payment')}
        type={articleType.PAYMENT}
        setData={data => setPaymentList(data)}
      />
    </Modal>
  );
}
